import { render, staticRenderFns } from "./veHqBgwpflEdit.vue?vue&type=template&id=48928bca&scoped=true"
import script from "./veHqBgwpflEdit.vue?vue&type=script&lang=js"
export * from "./veHqBgwpflEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48928bca",
  null
  
)

export default component.exports